export default "__VITE_ASSET__46V_7hNA__"